<p class="search-result-item d-flex m-0 py-2 px-3 small">
  <i class="modus-icons mr-2" style="font-size: large">{{ getIcon() }}</i>
  <span class="text-wrap">
    <span class="font-weight-bold" *ngIf="resultItem.POITypeID !== 0">
      {{ resultItem.ShortString }},&#32;</span
    >
    <span class="font-weight-bold" *ngIf="resultItem?.ResultType === 15">
      {{ resultItem.ShortString }}&#32;&#45;&#32;</span
    >
    <span
      *ngIf="resultItem.Address.StreetAddress !== ''"
      [ngClass]="{ 'font-weight-bold': resultItem.POITypeID === 0 }"
      >{{ resultItem.Address.StreetAddress }},&#32;</span
    >
    <span
      [ngClass]="{
        'font-weight-bold': resultItem.Address.StreetAddress === ''
      }"
      >{{ resultItem.Address.City }},&#32;</span
    >
    <span>{{ resultItem.Address.State }} {{ resultItem.Address.Zip }}</span>
  </span>
</p>
